import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { API_BASE_URL } from '../../config';
import { ValidDocumentParams } from '../../types';

export const documentApi = createApi({
  reducerPath: 'documentApi',
  baseQuery: fetchBaseQuery({ baseUrl: API_BASE_URL }),
  endpoints: builder => ({
    validateDocument: builder.mutation({
      query: (identification: ValidDocumentParams) => {
        return {
          url: 'validdocument',
          method: 'POST',
          body: { identification },
        };
      },
    }),
    validateEmail: builder.mutation({
      query: (email: string) => {
        return {
          url: 'validemail',
          method: 'POST',
          body: { email },
        };
      },
    }),
  }),
});

export const { useValidateDocumentMutation, useValidateEmailMutation } = documentApi;
